import React from 'react'
import GraphMenuItem from './GraphMenuItem'

const GraphSettingsMenuItemsSet = ({ dataViewType, setGraphMinMaxClickHandler, setThresholdClickHandlers, enableDisableSeriesClickHandler }) => {

  console.log('XXX setGraphMinMaxClickHandler',setGraphMinMaxClickHandler)

  let ret

  switch (dataViewType) {
    case 'graph_all_sensors':
    case 'graph_custom':
      ret = <div>
        <GraphMenuItem
          text={'Set Graph Min/Max'}
          clickHandler={setGraphMinMaxClickHandler}
        />
      </div>
      break
    break
    case 'graph_sdi12_moisture_rootzone_average_plus_discrete_lower':
      ret = <div>
        <GraphMenuItem
          text={'Set Thresholds'}
          clickHandler={setThresholdClickHandlers}
        />
      </div>
      break
    case 'graph_soil_profile_probe_moisture':
    case 'graph_sdi12_moisture_average':
    case 'graph_sdi12_moisture_sum':
    case 'graph_tension':
      ret = <div>
        <GraphMenuItem
          text={'Set Graph Min/Max'}
          clickHandler={setGraphMinMaxClickHandler}
        />
        <GraphMenuItem
          text={'Set Thresholds'}
          clickHandler={setThresholdClickHandlers}
        />
        {//<GraphMenuItem
          //text={'Enable/Disable Series'}
          //clickHandler={enableDisableSeriesClickHandler}
        ///>
        }
      </div>
      break;
    default:
      ret = null
  }

  console.log('XXX setGraphMinMaxClickHandler ret',ret)

  return ret

}

export default GraphSettingsMenuItemsSet



// WEBPACK FOOTER //
// ./src/components/dataViews/controls/GraphSettingsMenuItemsSet.js